import React from 'react'
import { Icon, Text } from 'components'
import styles from './AuctionDate.module.scss'

const AuctionDate = ({ label, date, hour }) => (
  <span className={styles.auctionDate}>
    <Icon type="auction" size={24} />
    <Text color="lightTextColor">{`${label} ${date} - Horário: ${hour}`}</Text>
  </span>
)

export default React.memo(AuctionDate)
